// Fixed assessment-template IDs for the CDR and FAST cognitive staging tools
// (see cli/system/audit/assessment.go on the backend).

export const CDR_TEMPLATE_ID = '000000000000000000000001';
export const FAST_TEMPLATE_ID = '000000000000000000000002';

export const COGNITIVE_STAGING_TEMPLATE_IDS = [CDR_TEMPLATE_ID, FAST_TEMPLATE_ID];

export function isCognitiveStagingTemplate(templateID) {
  return COGNITIVE_STAGING_TEMPLATE_IDS.includes(templateID);
}

export function joinScores(scores) {
  return (scores || []).map((s) => s.score).filter(Boolean).join(', ');
}
